/**
 * /connect-builder — signing dev.oS and the `paradigm` CLI in on a computer.
 *
 * The program listens on 127.0.0.1:<port>, opens this page with a PKCE challenge, and
 * the person is asked, a click and never a silent redirect. The code goes to the
 * loopback address and nowhere else, and is worth nothing to anything but the process
 * that asked. Drawn by DeviceSignIn, as every program of ours signing in is.
 *
 * A builder session reaches the developer surface and none of the graph
 * (backend/app/utils/builder_scope.py); the one thing it writes there is its sessions,
 * through the token `paradigm connect` makes over the "Agent sessions" realm.
 *
 * THE WAY BACK lands here too: once the program has exchanged the code it sends the
 * browser to `?done=signed-in | cancelled | failed` (cli/paradigm_cli/loopback.py).
 */
import { useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import DeviceSignIn from '../../components/grant/DeviceSignIn';
import { loopbackCallback } from './ConnectMacRoute';

export default function ConnectBuilderRoute() {
  const [params] = useSearchParams();
  const port = params.get('port');
  const challenge = params.get('code_challenge');

  return (
    <DeviceSignIn
      app="dev.oS" where="this computer" testId="connect-builder"
      device={(params.get('device') || '').trim()}
      asked="pressed Sign in in dev.oS or ran paradigm login"
      retry="Press Sign in in dev.oS, or run paradigm login"
      can={[
        'Manage your apps, plugins, schemas and groups',
        'Record your coding sessions in your graph, and read them back',
        'Show you the sessions your teams share with you',
      ]}
      cannot={['Read anything else in your graph', 'Change who can see your graph']}
      valid={!!(loopbackCallback(port, 'x', '') && challenge && challenge.length >= 43)}
      ended={params.get('done')}
      approve={async () => {
        const r = await api.createLoginHandoffCode('builder', challenge);
        const to = loopbackCallback(port, r.code, params.get('state'));
        if (!to) throw new Error('bad port');
        window.location.href = to;
      }}
      deny={() => {
        const to = loopbackCallback(port, '', params.get('state'));
        if (to) window.location.href = to.replace('code=&', 'error=access_denied&');
      }}
    />
  );
}
